"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var LoudspeakerFooter = function LoudspeakerFooter(_ref) {
  var onRemind = _ref.onRemind,
      onDismiss = _ref.onDismiss,
      t = _ref.t;
  return _react.default.createElement("div", {
    className: "loudspeakerFooter"
  }, _react.default.createElement("button", {
    type: "button",
    className: "loudspeakerFooter__secondaryButton",
    onClick: onRemind
  }, t('remindText')), _react.default.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: onDismiss
  }, t('dismissText')));
};

LoudspeakerFooter.propTypes = {
  onRemind: _propTypes.default.func.isRequired,
  onDismiss: _propTypes.default.func.isRequired,
  t: _propTypes.default.func.isRequired
};
var _default = LoudspeakerFooter;
exports.default = _default;